import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getCookie } from "./dbconnector/checktoken";


const loadResources = async (lng) => {
  try {
    const translations = await import(`../src/locales/${lng}.json`);
   
    //console.log(translations.default)
    return translations.default;
  } catch (e) {
    // fallback to English if file not found
    //console.log(   `Could not load translations for ${lng}, falling back to English.`,e);
    const translations = await import(`../src/locales/en.json`);
    //console.log(translations.default)
    return translations.default;
  }
};
const code = getCookie("language")

if (code !== "" && code !== null && code !== undefined) {
    let resources = await loadResources(code);

    i18n
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
            resources,
            lng: code,

            interpolation: {
                escapeValue: false // react already safes from xss
            }
        });

} else {
    let resources = await loadResources("en");
    i18n
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
            resources,
            lng: "en",

            interpolation: {
                escapeValue: false // react already safes from xss
            }
        });

}



export default i18n;